"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import Button from "@components/atoms/Button";
import { SearchInputProps } from "@interfaces/search-component.types";
import styles from "../../organisms/SearchComponent/SearchComponent.module.scss";
import assetLoader from "@utils/internalImageLoder";
import { isAppWithNativeHeader } from "@helpers/client/isAppWithNativeHeader";

export const SearchInput = ({
  variant,
  searchQuery,
  onSearch,
  onClear,
  onBack,
  onFocus,
  onKeyPress,
  isFocused,
  inputRef,
  placeholder
}: SearchInputProps) => {
  const [hideBackButton, setHideBackButton] = useState(false);

  useEffect(() => {
    setHideBackButton(isAppWithNativeHeader());
  }, []);

  return (
    <>
      {variant === "mobile" && onBack && !hideBackButton && (
        <Button onClick={onBack} className={styles.backButton}>
          <Image
            src={`${assetLoader()}/icons/Chevron_left_light.svg`}
            alt="Back"
            loading="lazy"
            width={24}
            height={24}
          />
        </Button>
      )}

      <input
        ref={inputRef}
        type="text"
        className={styles.searchInput}
        placeholder={placeholder ? placeholder : (
          variant === "desktop"
            ? "Search for cars..."
            : "What are you looking for?")
        }
        value={searchQuery}
        onChange={(e) => onSearch(e.target.value)}
        onFocus={onFocus}
        onKeyPress={onKeyPress}
      />

      {variant === "desktop" ? (
        !searchQuery ? (
          <Image
            src={`${assetLoader()}/icons/search.svg`}
            alt="Search"
            width={20}
            height={20}
            loading="lazy"
          />
        ) : (
          <Image
            src={`${assetLoader()}/icons/close_circular_light.svg`}
            alt="Clear"
            width={16}
            height={16}
            onClick={onClear}
            className={styles.clearIcon}
            loading="lazy"
          />
        )
      ) : (
        searchQuery && (
          <Button onClick={onClear} className={styles.clearButton}>
            <Image
              src={`${assetLoader()}/icons/close_circular_light.svg`}
              alt="Clear"
              width={20}
              height={20}
              loading="lazy"
            />
          </Button>
        )
      )}
    </>
  );
};

export default SearchInput;
